<script setup lang="ts">
import { computed } from "vue";
import { defineProps } from "vue";

/**
 * バッジコンポーネント。
 */

interface Props {
	/**
	 * 新着投稿バッジ表示日数
	 */
	postDate: string;

	/**
	 * 新着投稿バッジ文言
	 */
	newArrivalBadgeText: string;

	/**
	 * 新着投稿バッジ表示日数
	 */
	newArrivalBadgeDisplayDays: number;
}

const props = defineProps<Props>();

const isNew = computed(() => {
	const postDate = new Date(props.postDate);
	postDate.setHours(0, 0, 0, 0);
	const targetDate = new Date(Date.now());
	targetDate.setDate(targetDate.getDate() - props.newArrivalBadgeDisplayDays);
	targetDate.setHours(0, 0, 0, 0);

	return targetDate < postDate;
});
</script>

<template>
	<span v-if="isNew" class="revico-community-talk-details-new-arrival-badge">{{ newArrivalBadgeText }}</span>
</template>

<style scoped>
.revico-community-talk-details-new-arrival-badge {
	position: absolute;
	top: 8px;
	right: 0px;
	color: #f44336;
	font-weight: bold;
	padding: 0 4px 0 5px;
	background-color: #fff;
	border: 1px solid #f44336;
	border-radius: 12px;
}
</style>
